module.exports = __webpack_public_path__ + "img/stock7.6832da08.png";